export default __webpack_public_path__ + "static/media/cabello-mujer-pelirojo.0f463012.png";